import { checkStorageFormat, randomUvStr, getTimerByStr } from './util/str'
import { setUvStorage, getUvStorage } from './util/storage'

/**
 * 获取自定义uv
 *
 * @param {(string | (() => string))} [uv] 用户自定义uv参数值
 * @return {*}  {string} 计算后的自定义uv值
 */
function getFormattedUv (uv?: string | (() => string)): string {
  if (uv === undefined) return ''
  if (typeof uv === 'string') return uv
  if (typeof uv === 'function') return uv()
}

/**
 * 获取uvid
 * @param {Object} opts
 * @return {String} uvid
 */
export function getuvid(opts) {
  // 获取今天日期
  const date = new Date();
  let markUv: string = '';
  markUv = getUvStorage(opts);
  const { id, timer } = checkStorageFormat(markUv)
  const customId = getFormattedUv(opts.uv)
  if ( id && customId && customId !== id ) {
    // 修复问题：如果开发者之前未配置uv，使用sdk随机生成了uv，后期开发者又配置了自定义uv，且与已有的localStorage的uv不一致，则应该更新覆盖localStorage的uv为用户自定义的uv
    markUv = setUvStorage(opts, randomUvStr(opts.uv))
  } else if (id && timer) {
    const timerDate = getTimerByStr(timer)
    const isOneDay = (date.getFullYear() === timerDate.getFullYear()) && (date.getMonth() === timerDate.getMonth()) && (date.getDate() === timerDate.getDate());
    if (isOneDay) {
      markUv = id + '.' + timer
    } else {
      // 更新时间戳
      markUv = setUvStorage(opts, id)
    }
  } else {
    // 不存在则创建
    markUv = setUvStorage(opts, randomUvStr(opts.uv))
  }
  let uvid = markUv.split('.')
  uvid.pop()
  return uvid.join('.');
}
